export function createAsyncActionType(section = '', type = '') {
  const action = {
    _REQUEST: `@@${section.toLowerCase()}/${type.toUpperCase()}_REQUEST`,
    _SUCCESS: `@@${section.toLowerCase()}/${type.toUpperCase()}_SUCCESS`,
    _ERROR: `@@${section.toLowerCase()}/${type.toUpperCase()}_ERROR`,
  };

  return action;
}

// app
export const LOADER_OPEN = '@@global/LOADER_OPEN';
export const LOADER_CLOSE = '@@global/LOADER_CLOSE';
export const APP_MENU_TOGGLE = '@@global/APP_MENU_TOGGLE';
export const APP_NAVIGATION_TOGGLE = '@@global/APP_NAVIGATION_TOGGLE';
export const VOCABULARY_GET = createAsyncActionType('global', 'VOCABULARY_GET');
export const LOGO_GET = createAsyncActionType('global', 'LOGO_GET');
export const APP_STORE_RELOAD = '@@global/APP_STORE_RELOAD';
export const MODAL_OPEN = '@@global/MODAL_OPEN';
export const MODAL_CLOSE = '@@global/MODAL_CLOSE';
export const ACTION_TRACKING = createAsyncActionType(
  'global',
  'ACTION_TRACKING'
);

export const FAQ_GET = createAsyncActionType('global', 'FAQ_GET');
export const SSO_PROVIDER_LIST_GET = createAsyncActionType(
  'global',
  'SSO_PROVIDER_LIST_GET'
);
export const SUPPORT_MAIL_GET = createAsyncActionType(
  'global',
  'SUPPORT_MAIL_GET'
);

// auth
export const FIRST_AUTH_LOGIN = createAsyncActionType(
  'auth',
  'FIRST_AUTH_LOGIN'
);
export const OTP_AUTH_LOGIN = createAsyncActionType('auth', 'OTP_AUTH_LOGIN');
export const AUTH_LOGIN = createAsyncActionType('auth', 'AUTH_LOGIN');
export const AUTH_LOGIN_SSO = createAsyncActionType('auth', 'AUTH_LOGIN_SSO');
export const AUTH_LOGOUT = createAsyncActionType('auth', 'AUTH_LOGOUT');
export const AUTH_RESTORE_PASSWORD = createAsyncActionType(
  'auth',
  'AUTH_RESTORE_PASSWORD'
);
export const MAIL_SENT_RESET = '@@auth/MAIL_SENT_RESET';
export const AUTH_RESET_WITH_TOKEN = createAsyncActionType(
  'auth',
  'AUTH_RESET_WITH_TOKEN'
);

// activity state
export const SET_IS_ACTIVE = '@@global/SET_IS_ACTIVE';
